// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";

var defaultValue = {
  adminBetaAccessData: {
    admin: {
      id: -1,
      name: "n/a",
      email: "n/a"
    },
    page_config: []
  }
};

var context = React.createContext(defaultValue);

function useContext(param) {
  return React.useContext(context);
}

export {
  defaultValue ,
  context ,
  useContext ,
  
}
/* context Not a pure module */
